var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidePanelUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84913 7.07167C7.49987 6.37315 6.92835 5.81751 6.21396 5.5C5.67419 5.86514 5.0233 6.08739 4.3089 6.08739C3.61038 6.08739 2.95949 5.86514 2.40385 5.5C1.26082 6.00801 0.451172 7.15104 0.451172 8.48458V9.84987C0.451172 10.1198 0.657553 10.3261 0.927435 10.3261H6.81722V9.84987C6.81722 8.78622 7.19823 7.83369 7.84913 7.07167Z",
    fill: "#FD6202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3093 5.10298C5.62696 5.10298 6.70649 4.02345 6.70649 2.70578C6.70649 1.38812 5.62696 0.308594 4.3093 0.308594C2.99164 0.308594 1.91211 1.38812 1.91211 2.70578C1.91211 4.02345 2.99164 5.10298 4.3093 5.10298Z",
    fill: "#FD6202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5792 6.86328C13.0394 7.24429 12.3727 7.45067 11.6741 7.45067C10.9756 7.45067 10.3088 7.22842 9.76908 6.86328C8.61018 7.3713 7.81641 8.51433 7.81641 9.84786V11.2132C7.81641 11.483 8.03866 11.6894 8.29267 11.6894H15.0715C15.3414 11.6894 15.5477 11.483 15.5477 11.2132V9.84786C15.5319 8.51433 14.7222 7.35542 13.5792 6.86328Z",
    fill: "#1D3679"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6745 6.45454C12.9922 6.45454 14.0717 5.37501 14.0717 4.05735C14.0717 2.73969 12.9922 1.66016 11.6745 1.66016C10.3569 1.66016 9.27734 2.73969 9.27734 4.05735C9.27734 5.37501 10.341 6.45454 11.6745 6.45454Z",
    fill: "#1D3679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidePanelUserManagement);
export default __webpack_public_path__ + "static/media/sidePanelUserManagement.2ae9aee48f532e540b8f0d061fbfe898.svg";
export { ForwardRef as ReactComponent };